import Header from "../../Home/Header"
import Footer from "../../Home/Footer"

function Pot() {
  return (
    <div className="core">
      <Header />
        <h2 className="titre bloc">Le pot de Charles-Quint à Walcourt</h2>
        <div className="corePot bloc">
          <img className="imgLeft" src="http://www.legende-beaumont.be/wpimages/wpf6bc746f_05_06.jpg"></img>
          <p>Le grand empereur Charles-Quint, en visite dans ses Provinces du Nord, s’arrêta dans une auberge à Walcourt (Province de Namur – Belgique), pour se désaltérer.</p>
          <p>
Grand amateur de bière, (ne lui attribue-t-on pas cette phrase célèbre : « le sang de la vigne me convient bien moins que la fille de l’orge ! » ?) il demanda de pouvoir goûter la bière du pays. La patronne s’empressa d’apporter le divin breuvage, mais sans doute
très intimidée par le prestigieux personnage, elle lui tendit le pot en le tenant par la anse.</p>
<p>
Charles-Quint ne put donc s’en saisir. Il ordonna à son serviteur de faire livrer à l’aubergiste un pot à deux anses pour que, lors d’une prochaine visite, il puisse prendre le pot de bière d’une seule main.
A quelques temps de là, de nouveau de passage à Walcourt, il fit halte dans l’auberge.</p>
<p>
Mais la tenancière encore toute émue lui tendit son pot à bière, tenant fermement les deux anses.
Charles-Quint s’en saisit difficilement à deux mains, et loin de se décourager ordonna à son serviteur de faire livrer un pot à trois anses.
L’année suivante, plus par curiosité que par la soif, il fit une nouvelle halte dans l’auberge, pour vérifier que ses ordres avaient été suivis, et réclama son pot de bière.
</p>
<img className="imgRight" src="http://www.legende-beaumont.be/wpimages/wp92686306_06.png"></img>

<p>
La serveuse intimidée et sans doute un peu sotte, lui tendit le pot fermement maintenu par les deux anses, mais avec la troisième dirigée vers elle !
Charles-Quint, autant amusé qu’agacé dut donc passer sa main entre la chope et la poitrine de l’aubergiste pour se saisir du pot (ce qui était moins pratique qu’agréable), il garda toutefois son calme et ordonna à son fidèle serviteur de faire livrer un pot à quatre anses.
Lorsqu’il revint à l’auberge, le pot avait quatre anses opposées. L’empereur pouvait enfin prendre correctement sa bière et la déguster tranquillement.
Une autre légende fait état d’un pot de bière et de Charles-Quint : la légende du pot de Olen.
</p>
          </div>

      <Footer />

    </div>
  )
}

export default Pot